import React, {useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {debounce} from "lodash";
import {useFetch} from "../../../hooks/useFetch";
import {useStore} from "../../../hooks/useStore";

import {arrayAlphabeticalSort} from "../../../utils/helpers";
import {SubCompanyPropTypes} from "./FilterComponentPropTypes";
import {SelectField} from "./FilterComponentStyles";

const DEBOUNCE_TIMEOUT = 800;

const PoolCourierFilter = ({
    value,
    onChange,
    poolId,
    disabled = true,
    mode = undefined,
    allowClear = false,
    showLabel = true,
    selectMarginBottom = "20px"
}) => {
    const {t} = useTranslation();
    const stores = useStore();

    const [searchText, setSearchText] = useState("");
    const onSearch = useMemo(() => debounce(text => setSearchText(text), DEBOUNCE_TIMEOUT), []);

    // Arama sunucuda yapılır ve ilk 10 kurye gelir.
    const [loading, poolCouriersData, _, __] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.poolShiftStore.getPoolCouriers.bind(null, {
            poolId,
            searchText
        }),
        dependencies: [poolId, searchText],
        initialCall: Boolean(poolId),
        condition: poolId
    });
    const poolCouriers = poolCouriersData?.data || [];

    // Seçili kurye (ör. URL'den gelen) gelen 10 kuryenin arasında yoksa adı görünsün diye
    // ayrıca çekilir.
    const selectedCourierId = typeof value === "string" ? value : null;
    const isSelectedCourierMissing =
        Boolean(selectedCourierId) &&
        !poolCouriers.some(poolCourier => String(poolCourier._id) === selectedCourierId);
    const [, selectedCourierData] = useFetch({
        defaultDataValue: {},
        fetchFn: stores.courierStore.getCourier.bind(null, {courierId: selectedCourierId}),
        dependencies: [selectedCourierId, isSelectedCourierMissing],
        condition: isSelectedCourierMissing
    });
    const selectedCourier =
        isSelectedCourierMissing && String(selectedCourierData?.data?._id) === selectedCourierId
            ? selectedCourierData.data
            : null;
    const courierOptions = selectedCourier
        ? [selectedCourier, ...arrayAlphabeticalSort([...poolCouriers], "fullname")]
        : arrayAlphabeticalSort([...poolCouriers], "fullname");
    return (
        <React.Fragment>
            {showLabel && <h5>{t("fields.courier", {ns: "common"})}</h5>}
            <SelectField
                loading={loading}
                data-testid="subCompanySelect"
                value={value}
                onChange={onChange}
                // Yazarken her aramada loading açılıyor; kutu o sırada kilitlenirse odak kaçar.
                disabled={disabled && !poolId}
                mode={mode}
                mb={selectMarginBottom}
                showSearch
                onSearch={onSearch}
                filterOption={false}
                allowClear={allowClear}
            >
                {courierOptions.map(poolCourier => (
                    <SelectField.Option
                        key={poolCourier._id}
                        value={poolCourier._id}
                        data-testid="poolCourierSelect_option"
                    >
                        {poolCourier.fullname}
                    </SelectField.Option>
                ))}
            </SelectField>
        </React.Fragment>
    );
};

export default PoolCourierFilter;
